<script>
	import Helper from '../Classes/Helper';
	import Layout from '../Stores/Layout';
	import Product from '../Stores/Product';
	import Registry from '../Stores/Registry';

	function toggleRenderer(event) {
		$Registry.configurator_renderer = !$Registry.configurator_renderer;
	}

	function quotation() {
		Product.setStep(0, {force_validation: true});
		Layout.quotation();
	}
</script>

<style>
	div.zes-header {
		display: flex;
		padding-top: 1.75em;
		z-index: 20;
		backdrop-filter: blur(2em);
	}

	div.zes-header div {
		color: #FFF;
	}

	div.zes-header div.zes-brand {
		flex-grow: 1;
		margin-right: 2em;
		margin-left: 2em;
	}

	div.zes-header div.zes-brand div:nth-child(1) {
		font-size: 2.25em;
		text-shadow: .05em .05em 0 hsl(0deg 0% 0% / .3);
		font-weight: 400;
	}

	div.zes-header div.zes-brand div:nth-child(2) {
		font-size: .75em;
		font-weight: 700;
		opacity: .8;
	}

	div.zes-header div.zes-separator {
		width: 1px;
		height: 4em;
		margin-top: .75em;
		background: hsl(0deg 100% 100% / .25);
	}

	div.zes-header div.zes-price {
		padding-top: .75em;
		margin-left: 1.5em;
		margin-right: 1.5em;
	}

	div.zes-header div.zes-price div {
		font-size: 2.25em;
		font-weight: 600;
		letter-spacing: -.025em;
		text-shadow: .05em .05em 0 hsl(0deg 0% 0% / .3);
		color: var(--zes-2-3);
		cursor: pointer;
	}

	div.zes-header div.zes-price div i {
		font-size: .75em;
		vertical-align: middle;
		margin-left: .25em;
		color: hsl(0deg 0% 100% / .5);
	}

	div.zes-header div.zes-price:hover div,
	div.zes-header div.zes-price:hover div i {
		color: hsl(0deg 0% 100%);
	}

	div.zes-header div.zes-toggle {
		display: none;
		padding: 1.5em 1.5em 0 0;
	}

	div.zes-header div.zes-toggle i {
		font-size: 1.75em;
	}

	/* Responsive */

	@media only screen and (max-width: 1024px) and (orientation: portrait) {
		div.zes-header {
			font-size: .8em;
			padding-top: 0;
		}

		div.zes-header div.zes-brand {
			padding-top: .75em;
		}

		div.zes-header div.zes-brand div:nth-child(1) {
			font-size: 1.5em;
		}

		div.zes-header div.zes-price div i {
			display: none;
		}

		div.zes-header div.zes-toggle {
			display: block;
		}
	}
</style>

<div class="zes-header" on:click="{event => toggleRenderer(event)}">
	{#if Helper.is($Product)}
		<div class="zes-price" on:click="{event => quotation()}">
			<div>
				{Product.price($Product.price.total)}
				<i class="fa-light fa-circle-info"></i>
			</div>
		</div>
		<div class="zes-separator"></div>
		<div class="zes-brand">
			<div>{$Product.name}</div>
			<div>{$Product.make}</div>
		</div>
		<div class="zes-toggle">
			<i class="fa-sharp fa-solid fa-circle-chevron-{$Registry.configurator_renderer ? 'down' : 'up'}"></i>
		</div>
	{/if}
</div>